import { stringify } from 'csv-stringify/browser/esm/sync';
import platform from "../../../util/platform";
const create = (request) => {
    return (params) => {
        const path = `/progress/user/records/create`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, request);
    };
};
const invalidate = (userRecordId) => {
    return (params) => {
        const path = `/progress/user/records/invalidate/${userRecordId}`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, {});
    };
};
const invalidateByAdmin = (userRecordId) => {
    return (params) => {
        const path = `/progress/user/records/invalidate/${userRecordId}/admin`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, {});
    };
};
const invalidateAllByAdmin = (request) => {
    return (params) => {
        const path = `/progress/user/records/invalidate/admin`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, request);
    };
};
const updateAnnotation = (userRecordId, nextAnnotation) => {
    return (params) => {
        const path = `/progress/user/records/annotation/${userRecordId}/update`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, nextAnnotation);
    };
};
const invalidateForAccount = (accountId) => {
    return (params) => {
        const path = `/progress/user/records/account/${accountId}/invalidate`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, {});
    };
};
const getSubmissionsForAccount = (accountId) => {
    return (params) => {
        const path = `/progress/user/records/account/${accountId}/submissions`;
        return platform.get(params, platform.getEdgeBaseUrl(), path);
    };
};
const getSubmissions = () => {
    return (params) => {
        const path = `/progress/user/records/submissions`;
        return platform.get(params, platform.getEdgeBaseUrl(), path);
    };
};
const getSubmissionsPaginated = (request) => {
    return (params) => {
        const query = platform.buildPaginatedQuery(request);
        const path = `/progress/user/records/submissions/paginated?${query}`;
        return platform.get(params, platform.getEdgeBaseUrl(), path);
    };
};
const getQuizSubmissionsForAccount = (accountId) => {
    return (params) => {
        const path = `/progress/user/records/account/${accountId}/submissions/quiz`;
        return platform.get(params, platform.getEdgeBaseUrl(), path);
    };
};
const getQuizSubmissions = () => {
    return (params) => {
        const path = `/progress/user/records/submissions/quiz`;
        return platform.get(params, platform.getEdgeBaseUrl(), path);
    };
};
const getQuizSubmissionsPaginated = (request) => {
    return (params) => {
        const query = platform.buildPaginatedQuery(request);
        const path = `/progress/user/records/submissions/quiz/paginated?${query}`;
        return platform.get(params, platform.getEdgeBaseUrl(), path);
    };
};
const getQuizSubmissionsFiltered = (request) => {
    return (params) => {
        const path = `/progress/user/records/submissions/quiz/filtered`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, request);
    };
};
const getForCohort = (cohortId) => {
    return (params) => {
        const path = `/progress/user/records/cohort/${cohortId}`;
        return platform.get(params, platform.getEdgeBaseUrl(), path);
    };
};
const getForCohortForUsers = (cohortId, request) => {
    return (params) => {
        const path = `/progress/user/records/cohort/${cohortId}`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, request);
    };
};
const getForAccount = (accountId) => {
    return (params) => {
        const path = `/progress/user/records/account/${accountId}`;
        return platform.get(params, platform.getEdgeBaseUrl(), path);
    };
};
const getForAccountOverview = (accountId) => {
    return (params) => {
        const path = `/progress/user/records/account/${accountId}/overview`;
        return platform.get(params, platform.getEdgeBaseUrl(), path);
    };
};
const getHighAchievers = (dateRange) => {
    return (params) => {
        const path = `/progress/user/records/all/count/${dateRange}`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, {});
    };
};
const exportQuizSubmissions = (recordIds) => {
    return (params) => {
        const path = `/progress/user/records/submissions/quiz/export`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, recordIds).then((resp) => {
            const csvStr = stringify(resp.rows, { header: true, columns: resp.header });
            const blob = new Blob([csvStr], { type: 'text/csv;charset=utf-8' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'export.csv';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    };
};
const exportAllQuizSubmissions = () => {
    return (params) => {
        const path = `/progress/user/records/submissions/quiz/export/all`;
        return platform.get(params, platform.getEdgeBaseUrl(), path).then((resp) => {
            const csvStr = stringify(resp.rows, { header: true, columns: resp.header });
            const blob = new Blob([csvStr], { type: 'text/csv;charset=utf-8' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'export.csv';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    };
};
const user = {
    create,
    invalidate,
    invalidateByAdmin,
    invalidateAllByAdmin,
    updateAnnotation,
    invalidateForAccount,
    getForCohort,
    getForCohortForUsers,
    getForAccount,
    getForAccountOverview,
    getSubmissionsForAccount,
    getSubmissions,
    getSubmissionsPaginated,
    getQuizSubmissionsForAccount,
    getQuizSubmissions,
    getQuizSubmissionsPaginated,
    getQuizSubmissionsFiltered,
    getHighAchievers,
    exportQuizSubmissions,
    exportAllQuizSubmissions
};
export default user;
